'use client';

import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useCallback, useRef } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { FileBrowser } from './FileBrowser';
export interface FilePickerDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSelect: (files: any[]) => void;
  selectionMode?: 'single' | 'multiple';
  title?: string;
  initialType?: string[];
  initialStatus?: string;
  maxSelection?: number;
}
export function FilePickerDialog(t0) {
  const $ = _c(59);
  const {
    open,
    onOpenChange,
    onSelect,
    selectionMode: t1,
    title: t2,
    initialType,
    initialStatus,
    maxSelection
  } = t0;
  const selectionMode = t1 === undefined ? "single" : t1;
  const title = t2 === undefined ? "Select Files" : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  const [selectedIds, setSelectedIds] = useState(t3);
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = new Map();
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const selectedFilesMapRef = useRef(t4);
  let t5;
  let t6;
  if ($[2] !== open) {
    t5 = () => {
      if (!open) {
        setSelectedIds([]);
        selectedFilesMapRef.current = new Map();
      }
    };
    t6 = [open];
    $[2] = open;
    $[3] = t5;
    $[4] = t6;
  } else {
    t5 = $[3];
    t6 = $[4];
  }
  useEffect(t5, t6);
  let t7;
  let t8;
  if ($[5] !== open) {
    t7 = () => {
      if (!open) {
        const timer = setTimeout(_temp, 100);
        return () => clearTimeout(timer);
      }
    };
    t8 = [open];
    $[5] = open;
    $[6] = t7;
    $[7] = t8;
  } else {
    t7 = $[6];
    t8 = $[7];
  }
  useEffect(t7, t8);
  let t9;
  if ($[8] !== onOpenChange || $[9] !== onSelect || $[10] !== selectedIds) {
    t9 = () => {
      const selectedFiles = selectedIds.map(id => selectedFilesMapRef.current.get(id)).filter(Boolean);
      onSelect(selectedFiles);
      onOpenChange(false);
    };
    $[8] = onOpenChange;
    $[9] = onSelect;
    $[10] = selectedIds;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  const handleSelect = t9;
  let t10;
  if ($[12] !== maxSelection) {
    t10 = fileIds => {
      if (maxSelection && fileIds.length > maxSelection) {
        return;
      }
      setSelectedIds(fileIds);
      for (const id_0 of Array.from(selectedFilesMapRef.current.keys())) {
        if (!fileIds.includes(id_0)) {
          selectedFilesMapRef.current.delete(id_0);
        }
      }
    };
    $[12] = maxSelection;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const handleSelectionChange = t10;
  let t11;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = file => {
      selectedFilesMapRef.current.set(file.id, file);
    };
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const handleFileClick = t11;
  let t12;
  if ($[15] !== onOpenChange || $[16] !== onSelect || $[17] !== selectionMode) {
    t12 = file_0 => {
      if (selectionMode === "single") {
        onSelect([file_0]);
        onOpenChange(false);
      }
    };
    $[15] = onOpenChange;
    $[16] = onSelect;
    $[17] = selectionMode;
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  const handleFileDoubleClick = t12;
  const canSelect = selectedIds.length > 0;
  const selectionText = selectedIds.length === 0 ? "No files selected" : selectedIds.length === 1 ? "1 file selected" : `${selectedIds.length} files selected`;
  let t13;
  if ($[19] !== title) {
    t13 = <DialogTitle>{title}</DialogTitle>;
    $[19] = title;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  const t14 = selectionMode === "single" ? "Click to select a file" : maxSelection ? `Select up to ${maxSelection} files` : "Click to select multiple files";
  let t15;
  if ($[21] !== t14) {
    t15 = <p className="text-sm text-gray-500 mt-1">{t14}</p>;
    $[21] = t14;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] !== t13 || $[24] !== t15) {
    t16 = <DialogHeader className="px-6 py-4 border-b">{t13}{t15}</DialogHeader>;
    $[23] = t13;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== handleFileDoubleClick || $[27] !== handleSelectionChange || $[28] !== initialStatus || $[29] !== initialType || $[30] !== selectedIds || $[31] !== selectionMode) {
    t17 = <div className="flex-1 overflow-hidden"><FileBrowser selectionMode={selectionMode} selectedFileIds={selectedIds} onSelectionChange={handleSelectionChange} initialType={initialType} initialStatus={initialStatus} onFileClick={handleFileClick} onFileDoubleClick={handleFileDoubleClick} /></div>;
    $[26] = handleFileDoubleClick;
    $[27] = handleSelectionChange;
    $[28] = initialStatus;
    $[29] = initialType;
    $[30] = selectedIds;
    $[31] = selectionMode;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  let t18;
  if ($[33] !== maxSelection || $[34] !== selectionMode) {
    t18 = maxSelection && selectionMode === "multiple" && <span className="ml-2 text-gray-500">(max {maxSelection})</span>;
    $[33] = maxSelection;
    $[34] = selectionMode;
    $[35] = t18;
  } else {
    t18 = $[35];
  }
  let t19;
  if ($[36] !== selectionText || $[37] !== t18) {
    t19 = <div className="text-sm text-gray-600">{selectionText}{t18}</div>;
    $[36] = selectionText;
    $[37] = t18;
    $[38] = t19;
  } else {
    t19 = $[38];
  }
  let t20;
  if ($[39] !== onOpenChange) {
    t20 = <Button variant="outline" onClick={() => onOpenChange(false)}>Cancel</Button>;
    $[39] = onOpenChange;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  const t21 = !canSelect;
  const t22 = selectedIds.length > 0 && `(${selectedIds.length})`;
  let t23;
  if ($[41] !== handleSelect || $[42] !== t21 || $[43] !== t22) {
    t23 = <Button onClick={handleSelect} disabled={t21}>Select {t22}</Button>;
    $[41] = handleSelect;
    $[42] = t21;
    $[43] = t22;
    $[44] = t23;
  } else {
    t23 = $[44];
  }
  let t24;
  if ($[45] !== t20 || $[46] !== t23) {
    t24 = <div className="flex gap-2">{t20}{t23}</div>;
    $[45] = t20;
    $[46] = t23;
    $[47] = t24;
  } else {
    t24 = $[47];
  }
  let t25;
  if ($[48] !== t19 || $[49] !== t24) {
    t25 = <div className="px-6 py-4 border-t bg-gray-50 flex items-center justify-between">{t19}{t24}</div>;
    $[48] = t19;
    $[49] = t24;
    $[50] = t25;
  } else {
    t25 = $[50];
  }
  let t26;
  if ($[51] !== t16 || $[52] !== t17 || $[53] !== t25) {
    t26 = <DialogContent className="max-w-6xl h-[85vh] p-0 flex flex-col">{t16}{t17}{t25}</DialogContent>;
    $[51] = t16;
    $[52] = t17;
    $[53] = t25;
    $[54] = t26;
  } else {
    t26 = $[54];
  }
  let t27;
  if ($[55] !== onOpenChange || $[56] !== open || $[57] !== t26) {
    t27 = <Dialog open={open} onOpenChange={onOpenChange}>{t26}</Dialog>;
    $[55] = onOpenChange;
    $[56] = open;
    $[57] = t26;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  return t27;
}
function _temp() {
  document.body.style.overflow = "";
  document.body.style.pointerEvents = "";
}